<div class="l-section u-mt-sp-20 u-mt-tb-24 u-mt-pc-40">
  <div class="p-heading-area01">
    <!-- 3 搭乗者情報 -->
    <h2 class="p-heading-area01__title c-heading-2" [innerHTML]="'label.personalIinformation' | staticMsg"></h2>
  </div>
  <!-- [4.1] 搭乗者情報 -->
  <ng-container *ngFor="let traveler of travelers">
    <div class="p-manage-booking">
      <div class="p-manage-booking__item">
        <div class="p-manage-booking__item-head p-manage-booking__item-head--has-btn">
          <div class="p-manage-booking__item-title">
            <!-- [4.3] 搭乗者姓名 -->
            <div class="p-manage-booking__item-title-label p-manage-booking__item-title-label-em">
              {{ getTravelerName(traveler) }}
            </div>
            <!-- [4.4] 搭乗者種別 -->
            <div class="p-manage-booking__item-title-lead">{{ getPassengerTypeCode(traveler) }}</div>
          </div>
          <!-- [4.3] 搭乗者情報編集 -->
          <asw-button size="xs" (click$)="clickEditPassengerInformation(traveler)" *ngIf="isDisplayEditButton()">
            <span class="c-btn-primary__text" [innerHTML]="'label.edit' | staticMsg"></span>
          </asw-button>
        </div>
        <dl class="c-def-list02">
          <div class="c-def-list02__item">
            <dt class="c-def-list02__item-title" [innerHTML]="'label.personalIinformation' | staticMsg"></dt>
            <dd class="c-def-list02__item-body">
              <dl class="c-float-list01">
                <div class="c-float-list01__item" *ngIf="isShowDateOfBirth()">
                  <dt class="c-float-list01__title" [innerHTML]="'label.dateOfBirth' | staticMsg"></dt>
                  <!-- [4.5] 生年月日 -->
                  <dd class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal">
                    {{ getDateOfBirth(traveler) }}
                  </dd>
                </div>
              </dl>
            </dd>
          </div>
          <!-- [6.1] 障がい者種別の登録情報 -->
          <div class="c-def-list02__item" *ngIf="isDisplayRegistrationInformOfDisability(traveler)">
            <dt class="c-def-list02__item-title" [innerHTML]="'label.disabilityType' | staticMsg"></dt>
            <dd class="c-def-list02__item-body">
              <dl class="c-float-list01">
                <div class="c-float-list01__item">
                  <dt class="c-float-list01__title" [innerHTML]="'label.statusDisabilityTypeStatus' | staticMsg"></dt>
                  <!-- [6.2] 障がい者種別登録状況 -->
                  <dd class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal">
                    {{ getRegistrationStatusOfDisability(traveler) | staticMsg }}
                  </dd>
                </div>
              </dl>
            </dd>
          </div>
          <div class="c-def-list02__item" *ngIf="isDisplayRemoteIslandInformation(traveler)">
            <dt class="c-def-list02__item-title" [innerHTML]="'label.remoteIslandCardNumber' | staticMsg"></dt>
            <dd class="c-def-list02__item-body">
              <dl class="c-float-list01">
                <div class="c-float-list01__item">
                  <dt class="c-float-list01__title" [innerHTML]="'label.cardNumberRegistrationStatus' | staticMsg"></dt>
                  <dd class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal">
                    {{ getRemoteIslandInformation(traveler) | staticMsg }}
                  </dd>
                </div>
              </dl>
            </dd>
          </div>
          <ng-container *ngIf="isDisplayPassengerContactInfor(traveler)">
            <!-- [8.11] <搭乗者連絡先情報（米国旅程を含まない場合）-->
            <div class="c-def-list02__item">
              <dt class="c-def-list02__item-title" [innerHTML]="'label.passengerContactInformation' | staticMsg"></dt>
              <dd class="c-def-list02__item-body">
                <dl class="c-float-list01">
                  <!-- [8.12] 搭乗者メールアドレス登録状況 -->
                  <div class="c-float-list01__item" *ngIf="!isMoreThanOnePassengerEmail(traveler)">
                    <dt
                      class="c-float-list01__title"
                      [innerHTML]="'label.eMailAddress.passengerInput' | staticMsg"
                    ></dt>
                    <dd
                      class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal"
                      [innerHTML]="passengerEmailAddress(traveler) | staticMsg"
                    ></dd>
                  </div>
                  <!-- /[8.12] 搭乗者メールアドレス登録状況 -->

                  <!-- [8.13] 搭乗者メールアドレス -->
                  <div class="c-float-list01__item" *ngIf="isShowPassengerEmailAddress(traveler)">
                    <dt
                      class="c-float-list01__title"
                      [innerHTML]="'label.eMailAddress.passengerInput' | staticMsg"
                    ></dt>
                    <dd class="c-float-list01__contents c-float-list01__contents--fs16 u-weight-normal">
                      <ng-container *ngFor="let email of getPassengerEmailAddress(traveler)">
                        <!-- ※複数件の場合、メールアドレス毎に改行して表示する。 -->
                        <div>{{ email }}</div>
                      </ng-container>
                    </dd>
                  </div>
                  <!-- /[8.13] 搭乗者メールアドレス -->
                </dl>
              </dd>
            </div>
            <!-- /[8.11] <搭乗者連絡先情報（米国旅程を含まない場合）-->
          </ng-container>
          <!-- 12 発着通知連絡先について、下記の通りに表示する。-->
          <div class="c-def-list02__item c-def-list02__item--one" *ngIf="isDisplayArrivalDepartureAlert(traveler)">
            <!-- [12.1] 発着通知連絡先 -->
            <dt class="c-def-list02__item-title" [innerHTML]="'heading.arrivalDepartureAlertsMail' | staticMsg"></dt>
            <!-- 12.2 発着通知連絡先情報 -->
            <dd class="c-def-list02__item-body">{{ getArrivalDepartureAlertStatus(traveler) | staticMsg }}</dd>
          </div>
          <!-- [13] 搭乗者情報系サポート情報について、下記の通りに表示する。 -->
          <div class="c-def-list02__item c-def-list02__item--one" *ngIf="isDisplaySupportInformation(traveler)">
            <!-- [13.1] 搭乗者情報系サポート情報 -->
            <dt class="c-def-list02__item-title" [innerHTML]="'label.supportInformation' | staticMsg"></dt>
            <!-- [13.2]  サポート情報登録状況 -->
            <dd class="c-def-list02__item-body">{{ getSupportInformationStatus(traveler) }}</dd>
          </div>
        </dl>
      </div>
    </div>
  </ng-container>
</div>
